<template>
	<div class="s-gray-bg" style="min-height:100vh;padding-top: 1rem;">
		<div class="p-margin20 p-padding20 p-font1  p-black p-bold p-padding-top30 p-padding-bottom20">本阶段未达标，无法生成报告</div>		
		<div v-if="!isLoading" class="p-margin20 p-padding20  p-white-bg p-radius20 p-black"
			style="width: auto;height: auto;">
			
			<div class="p-padding-top30 p-padding-bottom10">
				<div class="p-line-height1 p-font1-1 p-black p-bold">
					{{visibleReportDays[0].date.substring(0,4)+$t('common.yearUnit')+visibleReportDays[0].date.substring(5,7)+$t('common.monthUnit')+visibleReportDays[0].date.substring(8,10)+$t('common.dayUnit')+'~'+visibleReportDays[6].date.substring(5,7)+$t('common.monthUnit')+visibleReportDays[6].date.substring(8,10)+$t('common.dayUnit')}}
				</div>
			</div>
			
			<div v-for="(item,index) in visibleReportDays" :Key="item.date" class="p-relative p-float-left"
				style="width:calc(100% / 7); padding-bottom:1rem;margin-top: 1rem;">
				<div class="p-box-center-x"> {{item.date.substring(8,10)}}</div>
				<div class="p-box-center-x">
					<img :src="(item.time6to8count>=2&&item.time17to19count>=2&&item.time20to24count>=2)? require('@/assets/img/bot_green.png') : require('@/assets/img/bot_red.png')"
						class="p-inline-block p-margin-top10" style="width:0.5rem; height:0.5rem;" />
				</div>
			</div>
			
			<div v-if="!isShowAll&&Object.keys(visibleReportDays).length>0" class="p-color6-border p-line-height2" style="width: auto;">
				<div class="p-margin-top20 p-font0-8">{{visibleReportDays[0].date}}
				</div>
				<div class="p-box-center-y  p-color6-border  " style="padding:0.3rem 0rem 0.3rem 0rem;">
					<img :src="visibleReportDays[0].time6to8count>=2 ? require('@/assets/img/bot_circle_green.png') : require('@/assets/img/bot_circle_red.png')"
						class="p-margin-left20 " style="width:0.8rem; height:0.8rem;" />

					<div class="p-font0-8 p-color3 p-margin-left30">
						06:00~08:00{{$t('measure.measurementsNumber')}}{{visibleReportDays[0].time6to8count<2?$t('common.dontReachStandard'):$t('common.reachStandard')}}
					</div>
				</div>
				<div class=" p-box-center-y  p-color6-border  "
					style="width:calc(100% - 1.5rem - 0.8rem); padding:0.3rem 0rem 0.3rem 0rem;">
					<img :src="visibleReportDays[0].time17to19count>=2 ? require('@/assets/img/bot_circle_green.png') : require('@/assets/img/bot_circle_red.png')"
						class="p-margin-left20 " style="width:0.8rem; height:0.8rem;" />

					<div class="p-font0-8 p-color3 p-margin-left30">
						17:00~19:00{{$t('measure.measurementsNumber')}}{{visibleReportDays[0].time17to19count<2?$t('common.dontReachStandard'):$t('common.reachStandard')}}
					</div>
				</div>
				<div class="p-box-center-y p-color6-border  p-margin-bottom10"
					style="width:calc(100% - 1.5rem - 0.8rem); padding:0.3rem 0rem 0.3rem 0rem;">
					<img :src="visibleReportDays[0].time20to24count>=2 ? require('@/assets/img/bot_circle_green.png') : require('@/assets/img/bot_circle_red.png')"
						class="p-margin-left20 " style="width:0.8rem; height:0.8rem;" />

					<div class="p-font0-8 p-color3 p-margin-left30">
						20:00~24:00{{$t('measure.measurementsNumber')}}{{visibleReportDays[0].time20to24count<2?$t('common.dontReachStandard'):$t('common.reachStandard')}}
					</div>
				</div>
			</div>
			
			<ul v-if="isShowAll&&Object.keys(visibleReportDays).length>0"
				class="p-radius20 p-black p-line-height2" style="width: auto;">
				<template>
					<div v-for="(v,k,i) in visibleReportDays" :key="k">
						<div class="p-border2 p-color6-border " :class="k===(visibleReportDays.length-1)?'p-border-none':''">
							<div class="p-margin-top20  p-font0-8" >{{v.date}}</div>
							<div class="p-box-center-y  p-color6-border  " style="padding:0.3rem 0rem 0.3rem 0rem;">
								<img :src="v.time6to8count>=2 ? require('@/assets/img/bot_circle_green.png') : require('@/assets/img/bot_circle_red.png')"
									class="p-margin-left20 " style="width:0.8rem; height:0.8rem;" />

								<div class="p-font0-8 p-color3 p-margin-left30">
									06:00~08:00{{$t('measure.measurementsNumber')}}{{v.time6to8count<2?$t('common.dontReachStandard'):$t('common.reachStandard')}}
								</div>
							</div>
							<div class=" p-box-center-y  p-color6-border  "
								style="width:calc(100% - 1.5rem - 0.8rem); padding:0.3rem 0rem 0.3rem 0rem;">
								<img :src="v.time17to19count>=2 ? require('@/assets/img/bot_circle_green.png') : require('@/assets/img/bot_circle_red.png')"
									class="p-margin-left20 " style="width:0.8rem; height:0.8rem;" />

								<div class="p-font0-8 p-color3 p-margin-left30">
									17:00~19:00{{$t('measure.measurementsNumber')}}{{v.time17to19count<2?$t('common.dontReachStandard'):$t('common.reachStandard')}}
								</div>
							</div>
							<div class="p-box-center-y p-color6-border  p-margin-bottom10"
								style="width:calc(100% - 1.5rem - 0.8rem); padding:0.3rem 0rem 0.3rem 0rem;">
								<img :src="v.time20to24count>=2 ? require('@/assets/img/bot_circle_green.png') : require('@/assets/img/bot_circle_red.png')"
									class="p-margin-left20 " style="width:0.8rem; height:0.8rem;" />

								<div class="p-font0-8 p-color3 p-margin-left30">
									20:00~24:00{{$t('measure.measurementsNumber')}}{{v.time20to24count<2?$t('common.dontReachStandard'):$t('common.reachStandard')}}
								</div>
							</div>
						</div>
					</div>
				</template>
			</ul>
			<div class="p-box-center p-margin-bottom10" @click="swipeShowAll()"
				>
				<img :src="isShowAll ? require('@/assets/img/expand_hide.png') : require('@/assets/img/expand_show.png')"
					class="p-margin-left20 " />

				<div class="p-font0-9 p-color3 p-margin-left10">
					{{isShowAll?$t('common.packUpMore'):$t('common.showAllMore')}}
				</div>
			</div>
				<div style="height: 0.5rem;"></div>
		</div>
		<div v-if="!isLoading" class="p-margin20 p-padding20  p-white-bg p-radius20 p-black p-margin-top30"
			style="width: auto;height: auto;">
			<div class="p-padding-top30 p-padding-bottom10 p-box-center-y">
				<span class="p-line-height1 p-font1-1 p-black p-bold">
					{{ $t('measure.bloodPressureMeasureAdvice') }}
				</span>
				<img src="../assets/img/icon_warning.png"
					class="p-margin-left20" />
			</div>
			<div class="p-padding-top10 p-padding-bottom10">
				<span class="p-line-height1-6 p-font0-8 p-black" v-html="suggest" style="word-break: break-all;">
					  
				</span>
			</div>
			<div >
				<span class="p-line-height1-4 p-font0-6 p-color3">
					{{ $t('measure.reprotDayReachStandard') }}
				</span>
			</div>
			<div class="p-padding-top10 p-padding-bottom10">
				<span class="p-line-height1-4 p-font0-6 p-color3">
					{{ $t('measure.reprotWeekReachStandard') }}
				</span>
			</div>
			<div style="height: 1rem;"></div>
		</div>
		<loading v-if="isLoading"></loading>

	</div>


</template>

<script>
	import loading from "../components/loading/loading";
	import mixins from '@/utils/mixins.js'
	export default {
		name: "bloodPressure",
		mixins: [mixins],
		components: {
			loading,
		},
		data() {
			return {
				isShowAll: false,
				title: '',
				isLoading: true,
				isSMSToasty: true, //是否短信通知
				isAppling: false,
				suggest:'',
				maxMin:40,
			}
		},
		methods: {
			swipeShowAll() {
				this.isShowAll = !this.isShowAll;
			},
		},
		created() {
			document.title =this.$t('measure.bloodPressureReachDetail')
			 console.log("applyFail:1-----this.$route.query-- ", this.$route.query);
			this.visibleReportDays=this.$route.query.days.statusList;
			 console.log("applyFail:1------- ", this.visibleReportDays);
			this.isLoading=false;
			var date=new Date();
			var date1=new Date(new Date().getTime()+24*60*60*1000);
			var date2=new Date(new Date().getTime()+48*60*60*1000);
			var date3=new Date(new Date().getTime()+72*60*60*1000);
			if((date.getHours()<8&&date.getMinutes()<this.maxMin)||(date.getHours()<19&&date.getMinutes()<this.maxMin&&this.visibleReportDays[6].time6to8count>=2)||(date.getHours()<24&&date.getMinutes()<this.maxMin&&this.visibleReportDays[6].time6to8count>=2&&this.visibleReportDays[6].time17to19count>=2)){//今天还有机会可以达标
				if(0==this.$route.query.days.count){
					this.suggest=this.$t('measure.reprotReachStandardAdvice1')+(date.getMonth()+1)+this.$t('common.monthUnit')+date.getDate()+this.$t('common.dayUnit')+','+(date1.getMonth()+1)+this.$t('common.monthUnit')+date1.getDate()+this.$t('common.dayUnit')+','+(date2.getMonth()+1)+this.$t('common.monthUnit')+date2.getDate()+this.$t('common.monthUnit')+this.$t('measure.reprotReachStandardAdvice2');
				}else if(1==this.$route.query.days.count){
					if(this.visibleReportDays[0].time6to8count>=2&&this.visibleReportDays[0].time6to8count>=2&&this.visibleReportDays[0].time6to8count>=2){
						this.suggest=this.$t('measure.reprotReachStandardAdvice1')+(date.getMonth()+1)+this.$t('common.monthUnit')+date.getDate()+this.$t('common.dayUnit')+','+(date1.getMonth()+1)+this.$t('common.monthUnit')+date1.getDate()+this.$t('common.dayUnit')+','+(date2.getMonth()+1)+this.$t('common.monthUnit')+date2.getDate()+this.$t('common.monthUnit')+this.$t('measure.reprotReachStandardAdvice2');
					}else{
						this.suggest=this.$t('measure.reprotReachStandardAdvice3');
					}
				}else if(2==this.$route.query.days.count){
					if(this.visibleReportDays[0].time6to8count>=2&&this.visibleReportDays[0].time6to8count>=2&&this.visibleReportDays[0].time6to8count>=2){
						this.suggest=this.$t('measure.reprotReachStandardAdvice3');
					}else{
						if((date.getHours()<19&&date.getMinutes()<this.maxMin&&this.visibleReportDays[6].time6to8count>=2)){
							this.suggest=this.$t('measure.reprotReachStandardAdvice4');
						}else if(date.getHours()<24&&date.getMinutes()<this.maxMin&&this.visibleReportDays[6].time6to8count>=2&&this.visibleReportDays[6].time17to19count>=2){
							this.suggest=this.$t('measure.reprotReachStandardAdvice5');
						}else{
							this.suggest=this.$t('measure.reprotReachStandardAdvice6');
						}
					}
				}
			}else {//今天没有机会可以达标
					if(0==this.$route.query.days.count){
						this.suggest=this.$t('measure.reprotReachStandardAdvice7')+(date1.getMonth()+1)+this.$t('common.monthUnit')+date1.getDate()+this.$t('common.dayUnit')+','+(date2.getMonth()+1)+this.$t('common.monthUnit')+date2.getDate()+this.$t('common.dayUnit')+','+(date3.getMonth()+1)+this.$t('common.monthUnit')+date3.getDate()+this.$t('common.monthUnit')+this.$t('measure.reprotReachStandardAdvice2');
					}else if(1==this.$route.query.days.count){
						if((this.visibleReportDays[0].time6to8count>=2&&this.visibleReportDays[0].time6to8count>=2&&this.visibleReportDays[0].time6to8count>=2)||(this.visibleReportDays[1].time6to8count>=2&&this.visibleReportDays[1].time6to8count>=2&&this.visibleReportDays[1].time6to8count>=2)){
							this.suggest=this.$t('measure.reprotReachStandardAdvice7')+(date1.getMonth()+1)+this.$t('common.monthUnit')+date1.getDate()+this.$t('common.dayUnit')+','+(date2.getMonth()+1)+this.$t('common.monthUnit')+date2.getDate()+this.$t('common.dayUnit')+','+(date3.getMonth()+1)+this.$t('common.monthUnit')+date3.getDate()+this.$t('common.monthUnit')+this.$t('measure.reprotReachStandardAdvice2');
						}else{
							this.suggest=this.$t('measure.reprotReachStandardAdvice8')+(date1.getMonth()+1)+this.$t('common.monthUnit')+date1.getDate()+this.$t('common.dayUnit')+','+(date2.getMonth()+1)+this.$t('common.monthUnit')+date2.getDate()+this.$t('common.monthUnit')+this.$t('measure.reprotReachStandardAdvice2');
						}
					}else if(2==this.$route.query.days.count){
						if(this.visibleReportDays[0].time6to8count>=2&&this.visibleReportDays[0].time6to8count>=2&&this.visibleReportDays[0].time6to8count>=2){
							if((this.visibleReportDays[1].time6to8count>=2&&this.visibleReportDays[1].time6to8count>=2&&this.visibleReportDays[1].time6to8count>=2)){
								this.suggest=this.$t('measure.reprotReachStandardAdvice7')+(date1.getMonth()+1)+this.$t('common.monthUnit')+date1.getDate()+this.$t('common.dayUnit')+','+(date2.getMonth()+1)+this.$t('common.monthUnit')+date2.getDate()+this.$t('common.dayUnit')+','+(date3.getMonth()+1)+this.$t('common.monthUnit')+date3.getDate()+this.$t('common.monthUnit')+this.$t('measure.reprotReachStandardAdvice2');
							}else{
								this.suggest=this.$t('measure.reprotReachStandardAdvice8')+(date1.getMonth()+1)+this.$t('common.monthUnit')+date1.getDate()+this.$t('common.dayUnit')+','+(date2.getMonth()+1)+this.$t('common.monthUnit')+date2.getDate()+this.$t('common.monthUnit')+this.$t('measure.reprotReachStandardAdvice2');
							}
						}else{
							this.suggest=this.$t('measure.reprotReachStandardAdvice9');
						}
					}
				}
				
			
		},
	}
</script>

<style scoped>

</style>
